import { Theme } from '@emotion/react';
import { Box, Chip, Divider, SxProps, Typography } from '@mui/material';
import ClientAvatar from 'components/shared/ClientAvatar';
import CopyableTextMUI from 'components/shared/CopyableText/CopyableText';
import zeplinColor from 'theme/Color';
import { Utilities } from 'utilities/utilities';
import { relationshipColorMap } from '../../data';
import { ContactType } from '../../types';
import { muiStyles } from './muiStyles';
import styles from './styles.module.css';

const Card = ({ contact, openModal }: { contact: ContactType; openModal: () => void }) => {
  const { name, contactRelationship, phone, email, lastContacted, profilePicture, roles } = contact;

  return (
    <Box sx={muiStyles.container} onClick={openModal}>
      <Box sx={muiStyles.header}>
        <ClientAvatar
          profilePicture={profilePicture}
          clientName={name}
          sx={muiStyles.clientAvatar}
        />
        <Box sx={muiStyles.headerContent}>
          <Box sx={muiStyles.nameAndRelationship}>
            <Typography variant='responsiveHeading4' sx={muiStyles.name}>
              {name}
            </Typography>
            <Chip
              label={
                <Typography variant='responsiveLabel1' sx={muiStyles.chipLabel}>
                  {Utilities.formatSnakeToTitle(contactRelationship)}
                </Typography>
              }
              sx={[relationshipColorMap[contactRelationship], muiStyles.chip] as SxProps<Theme>}
            />
          </Box>
          <Typography variant='responsiveBody3' sx={muiStyles.title}>
            {roles}
          </Typography>
        </Box>
      </Box>

      <Box sx={muiStyles.infoRow}>
        <img src='/assets/phone-icon.svg' alt='Phone logo' className={styles.image} />
        {!phone ? (
          <Typography variant='responsiveBody3' sx={{ color: zeplinColor.BasicBlack }}>
            {'N/A'}
          </Typography>
        ) : (
          <CopyableTextMUI textToCopy={phone} />
        )}
      </Box>
      <Box sx={muiStyles.infoRow}>
        <img src='/assets/mail-dark-icon.svg' alt='Email logo' className={styles.image} />
        <Typography
          component='a'
          href={email ? `mailto:${email}` : 'N/A'}
          variant='responsiveBody3'
          sx={{ ...muiStyles.email, cursor: email ? 'pointer' : 'default' }}
        >
          {email ? email : 'N/A'}
        </Typography>
      </Box>

      <Divider component='div' sx={muiStyles.divider} />

      <Box sx={muiStyles.infoRow}>
        <img src='/assets/clock-01.svg' alt='Contact' className={styles.image} />
        <Typography variant='responsiveBody3'>
          Last Contacted: {contact?.lastContacted ? Utilities.formatDate(lastContacted) : '-'}
        </Typography>
      </Box>
    </Box>
  );
};

export default Card;
